import React, { useState, useEffect } from "react";
import "./BusModifyForm.css";
import { DayPickerRangeController } from "react-dates";
import moment from "moment";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { Spinner } from "react-bootstrap"; // ✅ Added Spinner

const BusModifyForm = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Source/Destination states
  const [source, setSource] = useState({});
  const [destination, setDestination] = useState({});
  const [searchInput, setSearchInput] = useState("");
  const [searchInput2, setSearchInput2] = useState("");

  // Suggestions state
  const [showSourceSuggestions, setShowSourceSuggestions] = useState(false);
  const [showDestinationSuggestions, setShowDestinationSuggestions] =
    useState(false);
  const [cities2, setCities2] = useState([]);
  const [cities22, setCities22] = useState([]);

  // Loading state for spinner
  const [loadingSource, setLoadingSource] = useState(false);
  const [loadingDestination, setLoadingDestination] = useState(false);

  // Calendar state
  const [startDate, setStartDate] = useState(moment());
  const [focusedInput, setFocusedInput] = useState("startDate");
  const [calVisible, setCalVisible] = useState(false);
  const [date, setDate] = useState("");

  // 🔹 Prefill from URL params
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const from = params.get("from");
    const to = params.get("to");
    const journeyDate = params.get("journeyDate");
    const cityId = params.get("cityId");
    const desId = params.get("desId");

    if (from) {
      setSearchInput(from);
      setSource({ CityName: from, CityId: cityId });
    }
    if (to) {
      setSearchInput2(to);
      setDestination({ CityName: to, CityId: desId });
    }
    if (journeyDate) {
      setDate(journeyDate);
      setStartDate(moment(journeyDate));
    }
  }, [location.search]);

  // ==================
  // Date Functions
  // ==================
  const isSameDay = (date1, date2) =>
    date1 && date2 && date1.isSame(date2, "day");

  const renderDayContents = (day) => {
    const isSelected = startDate && isSameDay(day, startDate);
    let classNames = ["DayPicker-Day"];
    if (isSelected) classNames.push("DayPicker-Day--selected");

    return (
      <div className={classNames.join(" ")}>
        <span style={{ fontWeight: "600", fontSize: "13px" }}>
          {day.format("D")}
        </span>
      </div>
    );
  };

  const handleDatesChange = ({ startDate: newStartDate }) => {
    setStartDate(newStartDate);
    if (newStartDate) {
      setDate(newStartDate.format("YYYY-MM-DD"));
      setCalVisible(false);
      setFocusedInput(null);
    }
  };

  // ==================
  // API Fetch (Source + Destination)
  // ==================
  const fetchDatas = async (value, setter, setLoading) => {
    try {
      setLoading(true);
      const payload = { city: value };
      const response = await axios.post(
        "https://admin.travelsdata.com/api/Bus/City",
        payload
      );
      const json = response.data;

      const results = json.data
        .filter(
          (user) =>
            user &&
            ((user.CityName &&
              user.CityName.toLowerCase().includes(value.toLowerCase())) ||
              (user.CityId &&
                user.CityId.toString()
                  .toLowerCase()
                  .includes(value.toLowerCase())))
        )
        .map((user) => ({ ...user }))
        .sort((a, b) => a.CityName.localeCompare(b.CityName));

      setter(results);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (value) => {
    setSearchInput(value);
    if (value.length >= 3) {
      fetchDatas(value, setCities2, setLoadingSource);
    } else {
      setCities2([]);
    }
  };

  const handleInputChange2 = (value) => {
    setSearchInput2(value);
    if (value.length >= 3) {
      fetchDatas(value, setCities22, setLoadingDestination);
    } else {
      setCities22([]);
    }
  };

  // ==================
  // Search Submit
  // ==================
  const handleSearch = () => {
    const from = source.CityName || searchInput;
    const to = destination.CityName || searchInput2;

    if (!from || !to || !date) {
      alert("Please select source, destination and journey date");
      return;
    }

    const query = `?from=${encodeURIComponent(from)}&to=${encodeURIComponent(
      to
    )}&cityId=${source.CityId || ""}&desId=${
      destination.CityId || ""
    }&journeyDate=${date}`;

    navigate(`/buslisting${query}`);
  };

  return (
    <div className="busModifysearch-Main">
      <div className="busModifysearch">
        <img
          src="Images/flight_aero.png"
          alt=""
          style={{ width: "40px", marginRight: "10px" }}
        />

        {/* Source Input */}
        <div
          className="busModifysearchinputs"
          style={{ width: "30%", position: "relative" }}
        >
          <label className="busModifylabelstyling">Source City</label>
          <input
            type="text"
            className="busModifyinputstyling"
            placeholder="Enter source city"
            onFocus={() => {
              setSearchInput(""); // ✅ Clear when user clicks
              setSource({});
              setShowSourceSuggestions(true);
            }}
            onBlur={() =>
              setTimeout(() => setShowSourceSuggestions(false), 150)
            }
            value={searchInput}
            onChange={(e) => handleInputChange(e.target.value)}
          />
          {showSourceSuggestions && (
            <div className="busModify-suggestions">
              {loadingSource && (
                <div
                  style={{
                    padding: "10px 5px",
                    fontSize: "12px",
                    textAlign: "center",
                    margin: "auto",
                    width: "100%",
                    color: "black",
                  }}
                >
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />{" "}
                  Please wait we are fetching city list...
                </div>
              )}
              {!loadingSource &&
                cities2.map((city) => (
                  <div
                    key={city.CityId}
                    className="busModify-suggestion-item"
                    onClick={() => {
                      setSearchInput(city.CityName);
                      setSource(city);
                      setShowSourceSuggestions(false);
                    }}
                  >
                    {city.CityName}
                  </div>
                ))}
            </div>
          )}
        </div>

        {/* Destination Input */}
        <div
          className="busModifysearchinputs"
          style={{ width: "30%", position: "relative" }}
        >
          <label className="busModifylabelstyling">Destination City</label>
          <input
            type="text"
            className="busModifyinputstyling"
            placeholder="Enter destination city"
            onFocus={() => {
              setSearchInput2(""); // ✅ Clear when user clicks
              setDestination({});
              setShowDestinationSuggestions(true);
            }}
            onBlur={() =>
              setTimeout(() => setShowDestinationSuggestions(false), 150)
            }
            value={searchInput2}
            onChange={(e) => handleInputChange2(e.target.value)}
          />
          {showDestinationSuggestions && (
            <div className="busModify-suggestions">
              {loadingDestination && (
                <div
                  style={{
                    padding: "10px 5px",
                    fontSize: "12px",
                    textAlign: "center",
                    margin: "auto",
                    width: "100%",
                    color: "black",
                  }}
                >
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />{" "}
                  Please wait we are fetching city list...
                </div>
              )}
              {!loadingDestination &&
                cities22.map((city) => (
                  <div
                    key={city.CityId}
                    className="busModify-suggestion-item"
                    onClick={() => {
                      setSearchInput2(city.CityName);
                      setDestination(city);
                      setShowDestinationSuggestions(false);
                    }}
                  >
                    {city.CityName}
                  </div>
                ))}
            </div>
          )}
        </div>

        {/* Date Picker */}
        <div
          className="busModifysearchinputs"
          style={{ width: "15%", position: "relative" }}
        >
          <label className="busModifylabelstyling">Departure Date</label>
          <input
            type="text"
            className="busModifyinputstyling"
            value={startDate ? startDate.format("MM/DD/YYYY") : ""}
            onClick={() => setCalVisible(!calVisible)}
            readOnly
            placeholder="Select date"
          />

          {calVisible && (
            <div
              style={{
                position: "absolute",
                zIndex: 2000,
                top: "100%",
                left: 0,
              }}
            >
              <DayPickerRangeController
                startDate={startDate}
                endDate={null}
                onDatesChange={handleDatesChange}
                isOutsideRange={(day) => day.isBefore(moment(), "day")}
                focusedInput={focusedInput || "startDate"}
                onFocusChange={(focused) =>
                  setFocusedInput(focused || "startDate")
                }
                renderDayContents={renderDayContents}
                numberOfMonths={1}
                daySize={36}
              />
            </div>
          )}
        </div>

        {/* Search Button */}
        <div style={{ width: "15%" }}>
          <button className="busModifysearch-btn" onClick={handleSearch}>
            Search
          </button>
        </div>
      </div>
    </div>
  );
};

export default BusModifyForm;
